module.exports = __webpack_public_path__ + "static/kumadex-introductory-vocab-ea2b20d8aa2c1c075156773a22d2059a.png";